import type { SharedData } from "@src/context/ApplicationContext";
import { resolveUserRoleForFlow } from "@src/utils/entry-route-bootstrap";
import { useEffect, useMemo } from "react";

interface UseEntryUserRoleBootstrapOptions {
  enabled?: boolean;
  canvasIsInSalesforce: boolean;
  canvasIsLoading: boolean;
  isReferrerFlow?: boolean;
  currentUserRole?: SharedData["userRole"];
  setData: (key: keyof SharedData, value: any) => void;
}

export const useEntryUserRoleBootstrap = ({
  enabled = true,
  canvasIsInSalesforce,
  canvasIsLoading,
  isReferrerFlow,
  currentUserRole,
  setData,
}: UseEntryUserRoleBootstrapOptions) => {
  const resolvedUserRole = useMemo(() => {
    if (!enabled) {
      return undefined;
    }

    if (canvasIsLoading) {
      return undefined;
    }

    return resolveUserRoleForFlow(canvasIsInSalesforce, isReferrerFlow);
  }, [enabled, canvasIsInSalesforce, canvasIsLoading, isReferrerFlow]);

  useEffect(() => {
    if (!resolvedUserRole || currentUserRole === resolvedUserRole) {
      return;
    }

    setData("userRole", resolvedUserRole);
  }, [currentUserRole, resolvedUserRole, setData]);

  return resolvedUserRole;
};
